/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationCustomerGranteesQuery from '../graphql/queries/GetSimulationCustomerGranteesQuery.js';

const useGetSimulationCustomerGranteesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationCustomerGranteesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationCustomerGrantees: R.omit(['__typename'], data?.getSimulationCustomerGrantees_simulation_customer_grantees || {})
  };
};

export default useGetSimulationCustomerGranteesQuery;
